/** Plan page layout constants and outer sx helpers. */
export const RAIL_TASK_LIMIT = 8;
export const MOBILE_PAGE_PADDING = 1.5;

/** Desktop plan rail width: clamp(min, share×viewport, max). */
export const PLAN_RAIL_MIN_WIDTH_PX = 340;
export const PLAN_RAIL_MAX_WIDTH_PX = 460;
export const PLAN_RAIL_VIEWPORT_SHARE = 0.26;

export const PLAN_RAIL_FLEX = `0 0 clamp(${PLAN_RAIL_MIN_WIDTH_PX}px, ${PLAN_RAIL_VIEWPORT_SHARE * 100}vw, ${PLAN_RAIL_MAX_WIDTH_PX}px)`;

/**
 * Preferred rail width in CSS pixels for a given viewport width (jsdom/unit).
 * Mirrors CSS `clamp(min, share×vw, max)`.
 * @param {number} viewportWidthPx
 * @returns {number}
 */
export function planRailWidthPx(viewportWidthPx) {
  const preferred = viewportWidthPx * PLAN_RAIL_VIEWPORT_SHARE;
  return Math.min(
    PLAN_RAIL_MAX_WIDTH_PX,
    Math.max(PLAN_RAIL_MIN_WIDTH_PX, preferred),
  );
}

export const planPageOuterSx = (isBattlefield) => ({
  p: isBattlefield ? MOBILE_PAGE_PADDING : 3,
  display: 'flex',
  flexDirection: 'column',
  gap: MOBILE_PAGE_PADDING,
});
